import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthShell, { inputCls, primaryBtn } from "@/components/AuthShell";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ForgotPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const requestReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  const doReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please log in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  if (token) {
    return (
      <AuthShell title="Set a new password" subtitle="Choose a strong password for your account."
        footer={<Link to="/login" className="text-cobalt font-medium">Back to login</Link>}>
        <form onSubmit={doReset} className="space-y-4">
          <input data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="New password" />
          <button type="submit" disabled={loading} data-testid="reset-submit" className={primaryBtn}>{loading ? "Saving…" : "Update password"}</button>
        </form>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Reset your password" subtitle="We'll send a reset link to your email."
      footer={<Link to="/login" className="text-cobalt font-medium">Back to login</Link>}>
      {sent ? (
        <div data-testid="forgot-sent" className="bg-cobalt-light text-cobalt rounded-2xl p-5 text-sm">
          If that email exists, a reset link has been sent. Check the server logs for the link in this demo environment.
        </div>
      ) : (
        <form onSubmit={requestReset} className="space-y-4">
          <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="you@example.com" />
          <button type="submit" disabled={loading} data-testid="forgot-submit" className={primaryBtn}>{loading ? "Sending…" : "Send reset link"}</button>
        </form>
      )}
    </AuthShell>
  );
}
